import { atom } from 'jotai';

import type { Plan } from '@/fixtures/plans';

export const upgradePlanModalPlanAtom = atom<Plan['name'] | null>(null);
